import service from '@/services/superaccess'

const log = {
  state: {
    log_modal: false
  },
  mutations: {
    updateStatusLogModal (state, status) {
      state.log_modal = status
    }
  },
  getters: {
    getStatusLogModal (context) {
      return context.log_modal
    }
  },
  actions: {
    setStatusLogModal (context, payload) {
      context.commit('updateStatusLogModal', payload)
    },
    downloadRequestLog (context, payload) {
      return service.post('/api/req_logs/download/', context, { query: payload })
    }
  }
}

export default log



// WEBPACK FOOTER //
// app/javascript/src/store/logs.js